export default __webpack_public_path__ + "static/media/background-1129x627.7c55c11c.jpeg";